import { render, staticRenderFns } from "./MessageListMessageInline.vue?vue&type=template&id=71289578&scoped=true&functional=true&"
import script from "./MessageListMessageInline.vue?vue&type=script&lang=js&"
export * from "./MessageListMessageInline.vue?vue&type=script&lang=js&"
import style0 from "./MessageListMessageInline.vue?vue&type=style&index=0&id=71289578&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "71289578",
  null
  
)

export default component.exports